// Kurzinfo zerlegen (Tooltips.tsx): „Notiz schreiben (n)“ -> Text und Taste.
export interface TippText {
  text: string;
  taste: string | null;
}

/** Rein: „Notiz schreiben (n)“ -> { text: "Notiz schreiben", taste: "n" }; ohne Kürzel nur der Text. */
export function tippZerlegen(roh: string): TippText {
  const m = /^(.*?)\s*\(((?:[⌘⌃⌥⇧]|Strg|Ctrl|Cmd|Alt|Umschalt)\s?\S{1,5}|Esc|Enter|Eingabe|Tab|Leertaste|Entf|\S|\S\s\S)\)(.*)$/s.exec(roh.trim());
  if (!m) return { text: roh.trim(), taste: null };
  const rest = m[3].replace(/^[\s,;·-]+/, "");
  const text = [m[1], rest].filter(Boolean).join(rest.startsWith("·") ? " " : ", ").replace(/\s+/g, " ").trim();
  return { text: text || m[1], taste: m[2].trim() };
}
